<!-- Shipping Information Format -->
<div class="shipping-info-container">
  <div class="shipping-page" *ngFor="let invoice of invoices; let i = index">

    <!-- Header Section -->
    <div class="shipping-header">
      <div class="header-title">
        <h1>SHIPPING INSTRUCTION</h1>
      </div>
    </div>

    <!-- Main Content Table -->
    <div class="shipping-content">
      <table class="shipping-table">

        <!-- Shipper Information Row (Full Width) -->
        <tr>
          <td class="section-header" colspan="6">SHIPPER'S NAME AND BILL</td>
        </tr>

        <tr>
          <td colspan="6" class="section-content">
            <div class="shipper-info">
              <p><strong>IMPERIAL SOLUTIONS LTD.</strong></p>
              <p>2F-24 AOBADAI</p>
              <p>KITAKU KOBE 651-1231 JAPAN</p>
              <p>TEL: +81-78-201-5360</p>
              <p>FAX: +81-78-201-5374</p>
              <p>E-MAIL: info@imperialsolutions.jp</p>
            </div>
          </td>
        </tr>

        <!-- Consignee and Notify Party Row (Side by Side) -->
        <tr>
          <td class="section-header" colspan="3">CONSIGNEE</td>
          <td class="section-header" colspan="3">NOTIFY PARTY</td>
        </tr>

        <tr>
          <td colspan="3" class="section-content">
            <div class="consignee-info">
              <p><strong>{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</strong></p>
              <p>{{ invoice.order?.buyer_street_address }}</p>
              <p>{{ invoice.order?.buyer_city }}</p>
              <p>{{ invoice.order?.buyer_country }}</p>
              <p>TEL: {{ invoice.order?.buyer_telephone_no }}</p>
              <p>E-MAIL: {{ invoice.order?.buyer_email_address }}</p>
            </div>
          </td>
          <td colspan="3" class="section-content">
            <div class="notify-party-info">
              <p><strong>{{ invoice.order?.buyer_company_name || invoice.order?.buyer_consignee_name }}</strong></p>
              <p>{{ invoice.order?.buyer_street_address }}</p>
              <p>{{ invoice.order?.buyer_city }}</p>
              <p>{{ invoice.order?.buyer_country }}</p>
              <p>TEL: {{ invoice.order?.buyer_telephone_no }}</p>
              <p>E-MAIL: {{ invoice.order?.buyer_email_address }}</p>
            </div>
          </td>
        </tr>

        <!-- Shipping Company and Vessel Information -->
        <tr>
          <td class="section-header">SHIPPING COMPANY</td>
          <td class="section-header">VESSEL NAME</td>
          <td class="section-header">VOY</td>
          <td class="section-header">SAILING DATE</td>
          <td class="section-header">ARRIVAL DATE</td>
          <td class="section-header">LOADING PORT</td>
        </tr>

        <tr>
          <td class="section-content">{{ invoice.ship?.company || 'IMPERIAL SOLUTIONS LTD.' }}</td>
          <td class="section-content">{{ invoice.ship?.name || '-' }}</td>
          <td class="section-content">{{ invoice.ship?.voyage_no || '-' }}</td>
          <td class="section-content">{{ invoice.ship?.sailing_date ? formatDate(invoice.ship.sailing_date) : '-' }}</td>
          <td class="section-content">{{ invoice.ship?.arrival_date ? formatDate(invoice.ship.arrival_date) : '-' }}</td>
          <td class="section-content">{{ invoice.order?.from_port || 'ANY PORT IN JAPAN' }}</td>
        </tr>

        <!-- Final Destination -->
        <tr>
          <td class="section-header" colspan="6">FINAL DESTINATION - {{ getDestinationCountry(invoice) }}</td>
        </tr>

        <tr>
          <td colspan="6" class="section-content">
            <p><strong>{{ invoice.order?.to_port }}, {{ invoice.order?.to_country }}</strong></p>
          </td>
        </tr>

        <!-- Marks and Numbers -->
        <tr>
          <td class="section-header" colspan="3">MARKS AND NUMBERS</td>
          <td class="section-header" colspan="3">DESCRIPTION</td>
        </tr>

        <!-- Individual Vehicle Mode -->
        <tr *ngIf="viewMode !== 'merged' || !invoice.vehicles">
          <td colspan="3" class="section-content marks-section">
            <div class="marks-content">
              <p><strong>{{ invoice.vehicle?.stock_no || 'N/A' }}</strong></p>
            </div>
          </td>
          <td colspan="3" class="section-content description-section">
            <div class="description-content">
              <p><strong>USED RECONDITIONED VEHICLE(S)</strong></p>
              <p><strong>CHASSIS NUMBER (DM-{{ invoice.vehicle?.chassis_no }})</strong></p>
              <p><strong>ENGINE NUMBER ({{ invoice.vehicle?.stock_no || 'N/A' }})</strong></p>
              <p><strong>YEAR/MONTH ({{ invoice.vehicle?.year }}/{{ invoice.vehicle?.month || 'N/A' }})</strong></p>
              <p><strong>ENGINE TYPE ({{ invoice.vehicle?.engine || 'N/A' }} CC)</strong></p>
              <p><strong>FUEL TYPE ({{ invoice.vehicle?.fuel_type || 'PETROL' }})</strong></p>
              <p><strong>MILEAGE ({{ invoice.vehicle?.mileage || 'N/A' }})</strong></p>
              <p><strong>COLOR ({{ invoice.vehicle?.exterior_color || 'N/A' }})</strong></p>
              <p><strong>M1 SIZE (N/A)</strong></p>
              <p><strong>GROSS (N/A)</strong></p>
              <p><strong>{{ invoice.vehicle?.make }} {{ invoice.vehicle?.model }}</strong></p>
              <p><strong>YEAR: {{ invoice.vehicle?.year }}</strong></p>
              <p><strong>MODEL CODE: {{ invoice.vehicle?.body_type }}</strong></p>
              <p><strong>ENGINE: {{ invoice.vehicle?.engine }} CC</strong></p>
              <p><strong>TRANSMISSION: {{ invoice.vehicle?.transmission }}</strong></p>
              <div class="freight-prepaid">
                <p><strong>"FREIGHT PREPAID"</strong></p>
              </div>
            </div>
          </td>
        </tr>

        <!-- Merged Vehicles Mode -->
        <tr *ngIf="viewMode === 'merged' && invoice.vehicles">
          <td colspan="3" class="section-content marks-section">
            <div class="marks-content">
              <div *ngFor="let vehicle of invoice.vehicles; let idx = index" class="vehicle-marks">
                <p><strong>{{ vehicle.stock_no || 'N/A' }}</strong></p>
                <hr *ngIf="idx < invoice.vehicles.length - 1" class="vehicle-separator">
              </div>
            </div>
          </td>
          <td colspan="3" class="section-content description-section">
            <div class="description-content">
              <p><strong>USED RECONDITIONED VEHICLE(S) - {{ getVehicleCount(invoice) }} UNITS</strong></p>
              <div *ngFor="let vehicle of invoice.vehicles; let idx = index" class="vehicle-description">
                <p><strong>VEHICLE {{ idx + 1 }}:</strong></p>
                <p><strong>CHASSIS NUMBER (DM-{{ vehicle.chassis_no }})</strong></p>
                <p><strong>ENGINE NUMBER ({{ vehicle.stock_no || 'N/A' }})</strong></p>
                <p><strong>YEAR/MONTH ({{ vehicle.year }}/{{ vehicle.month || 'N/A' }})</strong></p>
                <p><strong>ENGINE TYPE ({{ vehicle.engine || 'N/A' }} CC)</strong></p>
                <p><strong>FUEL TYPE ({{ vehicle.fuel_type || 'PETROL' }})</strong></p>
                <p><strong>MILEAGE ({{ vehicle.mileage || 'N/A' }})</strong></p>
                <p><strong>COLOR ({{ vehicle.exterior_color || 'N/A' }})</strong></p>
                <p><strong>M1 SIZE (N/A)</strong></p>
                <p><strong>GROSS (N/A)</strong></p>
                <p><strong>{{ vehicle.make }} {{ vehicle.model }}</strong></p>
                <p><strong>YEAR: {{ vehicle.year }}</strong></p>
                <p><strong>MODEL CODE: {{ vehicle.body_type }}</strong></p>
                <p><strong>ENGINE: {{ vehicle.engine }} CC</strong></p>
                <p><strong>TRANSMISSION: {{ vehicle.transmission }}</strong></p>
                <hr *ngIf="idx < invoice.vehicles.length - 1" class="vehicle-separator">
              </div>
              <div class="freight-prepaid">
                <p><strong>"FREIGHT PREPAID"</strong></p>
              </div>
            </div>
          </td>
        </tr>

        <!-- Remarks Section -->
        <tr>
          <td class="section-header" colspan="6">REMARKS</td>
        </tr>

        <tr>
          <td colspan="6" class="section-content remarks-section">
            <div class="remarks-content">
              <p></p>
            </div>
          </td>
        </tr>

        <!-- Booking and Place Information -->
        <tr>
          <td class="section-header" colspan="3">BOOKING NO.</td>
          <td class="section-header" colspan="3">PLACE OF ISSUE</td>
        </tr>

        <tr>
          <td colspan="3" class="section-content">{{ invoice.order?.order_number || invoice.invoice_number || '-' }}</td>
          <td colspan="3" class="section-content">KOBE, JAPAN</td>
        </tr>

      </table>
    </div>

    <!-- Footer Note -->
    <div class="shipping-footer">
      <div class="footer-note">
        <p><strong>NOTE: PLEASE RE-CONFIRM THE ABOVE INFORMATION</strong></p>
      </div>

      <div class="page-info">
        <p>Page No. 1</p>
      </div>
    </div>

    <!-- Page Break (except for last invoice) -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
